import { apiConfig } from '../api-config';

export const deleteVoucher = (codeVoucher: string, tokenKey: string, document: string) => apiConfig
  .delete(`api/Voucher/deleteVoucher?codeVoucher=${codeVoucher}&tokenKey=${tokenKey}&document=${document}`)
  .then((response) => response.data)
  .catch((error) => ({ error, hasError: true }));
